import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/administration/users/$id/')({
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/administration/users/$id/general', params, replace: true })
    },
})
